module.exports = __webpack_public_path__ + "img/logo-government-2.af0bab69.png";